import React from 'react';
import SectionHeader from '../SectionHeader.jsx';
import Classnames from 'classnames';
import _ from 'lodash';
import autoBind from 'react-autobind';
import Constants from '../../../constants/PensionPaymentConstants.js';

export default class PensionPaymentReview extends React.Component {
    
    constructor(props) {
        super(props);
        autoBind(this);
    }

    renderHeader() {
        return (<SectionHeader sectionId={this.props.sectionId} handlePencilClick={this.props.handlePencilClick} sectionName={this.props.sectionName} />);
    }

    renderSimpleReview(data, idx) {

        const isBankAccountDetails = data.label === Constants.Labels.NAME_ACC_HOLDER_LABEL || data.label === Constants.Labels.BRANCH_NUMBER_LABEL || data.label === Constants.Labels.ACC_NUMBER_LABEL;
        const colClass = Classnames('row', {'simple-review-row-subsection': data.subsection}, {'simple-review-row': !data.subsection});
        const col1 = isBankAccountDetails? 'col-xs-4' : 'col-xs-7';
        const col2 = isBankAccountDetails? 'col-xs-8' : 'col-xs-5';

        return data.label === Constants.Labels.YEARLY_FREQUENCY_TEXT_LABEL && data.value
        ?   (<div key={`pensPayment_confirm_${idx}_row`} className={colClass}>
                <div className="col-xs-12">
                    <div className="simple-review-value">{data.value}</div>
                </div>
            </div>)
        :   (<div key={`pensPayment_confirm_${idx}_row`} className={colClass}>
                <div className={col1}>
                    <span>{ data.label }</span>
                </div>
                <div className={col2}>
                    <div className="simple-review-value">{data.value}</div>
                </div>
            </div>);
    }

    renderInvestmentOptions() {

        const investmentOptionType = _.get(_.find(this.props.items, (o) => { return o.label === Constants.Labels.DRAW_DOWN_OPTION_LABEL }), 'value', '');
        let investOptionItems = this.props.investOptionItems;

        if (investOptionItems.length) {
            if (investmentOptionType === 'By order') {
                investOptionItems = _.sortBy(investOptionItems, (o) => { return o.order; });
                return investOptionItems.map((item, idx) => {
                    let classProp = idx+1 === investOptionItems.length? 'simple-review-row-subsection' : 'simple-review-row';

                    return (
                        <div key={`pensPayment_invstOpt_${idx}_row`} className={`row ${classProp}`}>
                            <div className="col-xs-4">
                                {`${item.order}. ${item.name}`}
                            </div>
                            <div className="col-xs-8">
                                {`# ${item.code}`}
                            </div>
                        </div>
                    )
                });
            } else {
                return investOptionItems.map((item, idx) => {
                    let classProp = idx+1 === investOptionItems.length? 'simple-review-row-subsection' : 'simple-review-row';

                    return (
                        <div key={`pensPayment_invstOpt_${idx}_row`} className={`row ${classProp}`}>
                            <div className="col-xs-12">
                                {item.name}
                            </div>
                            <div className="col-xs-12 investment-allocation-percentage">
                                <div className="col-xs-4">
                                    {`# ${item.code}`}
                                </div>
                                <div className="col-xs-8">
                                    <span>Percentage</span>{item.weight}
                                </div>
                            </div>
                        </div>
                    )
                });
            }
        }
    }

    render() {
        let items = this.props.items;
        const sectionHeader = (this.props.items && this.props.items.length > 0) ? this.renderHeader() : null;

        return (
            <section className="confirm-simple-review" id={this.props.sectionId}>
                <div className="container">
                    { sectionHeader }
                    { items.map(this.renderSimpleReview, this) }<br/>
                    <section className="pens-payment-investment-allocation">
                        { this.renderInvestmentOptions() }
                    </section>
                </div>
            </section>
        )
    }
}

PensionPaymentReview.propTypes = {
    items: React.PropTypes.array.isRequired,
    sectionName: React.PropTypes.string.isRequired,    
    sectionId: React.PropTypes.string,
    investOptionItems: React.PropTypes.array.isRequired
};


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ConfirmDetails/PensionPayment/PensionPaymentReview.jsx